import store from "store";
import parentApi from "store/parentApi";
import notification from "components/common/notification/notification";
import { getSocialSocketURL } from "utils/env";
import { getCookie } from "utils/cookie";
import { AUTH_TOKEN_COOKIE_KEY } from "constants";

let socket = null;
let reconnectTimer = null;
let manualClose = false;

const buildNotifMessage = (n) => {
  if (!n) return "New notification";
  const actorName = n?.payload?.actor?.name || "Someone";
  switch (n.type) {
    case "follow_request":
      return `${actorName} requested to follow you`;
    case "follow_accepted":
      return `${actorName} accepted your follow request`;
    case "new_follower":
      return `${actorName} started following you`;
    case "content_shared":
      return `${actorName} recommended "${n?.payload?.title || "content"}" to you`;
    default:
      return "New notification";
  }
};

const handleMessage = (evt) => {
  let msg;
  try {
    msg = JSON.parse(evt.data);
  } catch (e) {
    return;
  }
  const { event, data } = msg || {};

  switch (event) {
    case "feed:new":
      window.dispatchEvent(new CustomEvent("social:feed:new", { detail: data }));
      break;
    case "notification:new":
      store.dispatch(parentApi.util.invalidateTags(["notifications"]));
      window.dispatchEvent(
        new CustomEvent("social:notification", { detail: data })
      );
      if (data?.notification) {
        notification.info({ message: buildNotifMessage(data.notification) });
      }
      break;
    case "follow_request:new":
      store.dispatch(
        parentApi.util.invalidateTags(["followRequests", "notifications"])
      );
      window.dispatchEvent(
        new CustomEvent("social:follow_request", { detail: data })
      );
      break;
    case "follow_request:resolved":
      if (data?.user_code) {
        store.dispatch(
          parentApi.util.invalidateTags([
            { type: "relationship", id: data.user_code },
            { type: "socialProfile", id: data.user_code },
          ])
        );
      }
      window.dispatchEvent(
        new CustomEvent("social:follow_resolved", { detail: data })
      );
      break;
    default:
      break;
  }
};

const scheduleReconnect = () => {
  if (reconnectTimer || manualClose) return;
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    connectSocialSocket();
  }, 5000);
};

export const connectSocialSocket = () => {
  const token = getCookie(AUTH_TOKEN_COOKIE_KEY);
  if (!token) return;
  if (
    socket &&
    (socket.readyState === WebSocket.OPEN ||
      socket.readyState === WebSocket.CONNECTING)
  ) {
    return;
  }
  manualClose = false;

  try {
    socket = new WebSocket(
      `${getSocialSocketURL()}?token=${encodeURIComponent(token)}`
    );
  } catch (e) {
    scheduleReconnect();
    return;
  }

  socket.onmessage = handleMessage;
  socket.onclose = () => {
    socket = null;
    scheduleReconnect();
  };
  socket.onerror = () => {
    try {
      socket && socket.close();
    } catch (e) {
      // ignore
    }
  };
};

export const disconnectSocialSocket = () => {
  manualClose = true;
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  if (socket) {
    try {
      socket.close();
    } catch (e) {
      // ignore
    }
    socket = null;
  }
};
